import { MixedTuple } from '@juln/type-fest';
import { ENHANCE_TYPE } from '@meitu/image-enhance';
import { FuncListType } from '@meitu/saas-editor-core/es/version-types';
import { FetchPPTResponseData } from '@/services/ppt/index.d';
import { FetchRecordDetailResponseData } from '@/services/record/index.d';
import { ITeamTemplateDetail } from '@/services/team/index.d';
import { FetchUserTemplateResponseData } from '@/services/template/index.d';

export enum AIMaterialCreateType {
    'photo' = 1,
    'bg' = 2,
}

export enum AIMaterialCreateMode {
    'textToPic' = 1,
    'picToPic' = 2,
}

export type PolicyStrategyType = 'times_limit' | 'unlimited'; //限免类型：times_limit=次数限免；unlimited=无限次数
export type PolicyLimitType = 'gid' | 'uid'; // 要限制的对象是gid还是uid
export type PolicyUserCategory = 'vip' | 'normal'; // 要限制的对象是会员还是非会员：vip=会员；normal=非会员
export type TimeLimitType = 'forever' | 'today' | 'total'; // 限免次数类型，today = 每日， total=终身，forever表示非次数限免

export type PolicyInfo = {
    leftNum?: number;
    policyStrategyType?: PolicyStrategyType;
    policyLimitType?: PolicyLimitType;
    policyUserCategory?: PolicyUserCategory;
    timeLimitType?: TimeLimitType;
};

export type QualityCommercialConfig = Record<ENHANCE_TYPE, PolicyInfo>;

export const subFuncInfo: QualityCommercialConfig = {
    [ENHANCE_TYPE.SD]: {},
    [ENHANCE_TYPE.HD]: {},
    [ENHANCE_TYPE.HDU]: {},
};

export interface IThresholdIdMap {
    iconName?: string;
    id?: number | FuncListType;
    isVip: boolean;
    name: string;
    type?: string;
    typeId?: number;
    typeName: string;
    url: string;
    trackName?: string;
    // 保存上报的参数，在水印渲染里处理
    saveTrackParam?: string;
    // 版权提醒素材排序
    sort?: number;
    // 素材类型
    format?: string;
}
export interface IThresholdClientListType {
    name: string;
    iconName: string;
}

export interface IClientList {
    name: string;
    iconName: string;
    typeName: string;
    url: string;
    isVip: boolean;
    typeId: number;
    id: string;
    type: string;
}

export interface IMaterialList {
    id: number;
    status: number;
    threshold: number;
    thumbnail?: string;
    type: string;
    type_id?: number;
    default_name: string;
    name?: string;
    // 1 svg, 0 图片
    stick_type?: number;
}

export type TemplateResponseData = MixedTuple<
    FetchUserTemplateResponseData | FetchRecordDetailResponseData | FetchPPTResponseData | ITeamTemplateDetail
>;
